import React from 'react';
import { Card, CardHeader, CardBody, CardExpandToggler } from '../../../components/card/card.jsx';

/**
 * Component for displaying scan progress logs
 */
const ProgressLog = ({ 
  isVisible, 
  progressLogs, 
  progressPercentage, 
  isLoading 
}) => {
  if (!isVisible) return null;

  const getLogTypeClass = (type) => {
    switch (type) {
      case 'error': return 'text-danger';
      case 'success': return 'text-success';
      case 'warning': return 'text-warning';
      case 'debug': return 'text-info';
      default: return 'text-light';
    }
  };

  const getLogTypeIcon = (type) => {
    switch (type) {
      case 'error': return 'fa-exclamation-triangle';
      case 'success': return 'fa-check-circle';
      case 'warning': return 'fa-exclamation-circle';
      case 'debug': return 'fa-bug';
      default: return 'fa-info-circle';
    }
  };

  return (
    <Card>
      <CardHeader className="fw-bold small text-white bg-dark">
        <i className="fa fa-terminal me-2"></i>Pentest Progress Log
        <CardExpandToggler />
      </CardHeader>
      <CardBody>
        {/* Progress Bar */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="small fw-bold">Scan Progress</span>
            <span className="small">{progressPercentage}%</span>
          </div>
          <div className="progress" style={{ height: '8px' }}>
            <div 
              className="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar" 
              style={{ width: `${progressPercentage}%` }}
              aria-valuenow={progressPercentage} 
              aria-valuemin="0" 
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        {/* Log Container */}
        <div 
          className="bg-dark text-light p-3 rounded" 
          style={{ 
            height: '300px', 
            overflowY: 'auto', 
            fontFamily: 'monospace', 
            fontSize: '0.85rem' 
          }}
        >
          {progressLogs.length === 0 ? (
            <div className="text-muted">No logs available...</div>
          ) : (
            progressLogs.map((log, index) => (
              <div key={index} className="mb-1">
                <span className="text-muted me-2">[{log.timestamp}]</span>
                <i className={`fa ${getLogTypeIcon(log.type)} me-2 ${getLogTypeClass(log.type)}`}></i>
                <span className={getLogTypeClass(log.type)}>{log.message}</span>
              </div>
            ))
          )}
          
          {/* Loading indicator */}
          {isLoading && (
            <div className="mt-2">
              <span className="text-info">
                <i className="fa fa-spinner fa-spin me-2"></i>
                Scanning in progress...
              </span>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ProgressLog;